import { getImage } from '@Container/common/client/spring/utils/cutImg';

/**
 * 格式化封面图
 * @param {Object} item 数据
 * @param {Number} w 动态裁图宽
 * @param {Number} h 动态裁图高
 */
const formatThumbnail = (item, w, h) => {
    let thumbnail = '';

    if (item.thumbnails && item.thumbnails.image && item.thumbnails.image.length > 0) {
        thumbnail = getImage(item.thumbnails.image[0].url, w, h);
    } else if (item.thumbnail) {
        thumbnail = getImage(item.thumbnail, w, h);
    } else {
        thumbnail = '';
    }

    return thumbnail;
};

export default formatThumbnail;
